import React, { Component } from 'react';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Header from './Header';
import itemImg from '../assets/images/closed-collection-details/item-image.png';
import user3 from '../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-3.png';

class ClosedCollectionDetails extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Item details area start */}
                <div className="container mb-3">
                    <div className="row collection justify-content-between">
                        <div className="col-md-6 upcoming-collection">
                            <img src={itemImg} alt="" width="100%" />
                            <p><Link to="#">VIEW COLLECTION</Link>
                                <small className="pull-right">Contract Address</small>
                            </p>
                            <small className="pull-right">0xbfb69918f12eed843c67058b2ee9059f1440133e</small>
                        </div>

                        <div className="col-md-5 upcoming mt-auto mb-4 closed-collection-text">
                            <h3>Duke Dumont</h3>
                            <h1>Flower Face - Day
                                <span>
                                    $1,944.00
                                </span>
                            </h1>
                            <hr />
                            <p>Many Faces Open Editions
                                <span>Edition of 15</span>
                            </p>
                            <p>Flower Face - Day: Art by Grif, Music by Disclosure. This open edition is helping to raise money for organizations working on reforestation, empowering women & rebuilding ecosystems, such as our partners @JustDigIt who are doing fantastic work. Disclosure went to Kenya last year to see it in action & said was truly incredible.</p>
                            <button>PLACE BID</button>
                            <h6><Link to="#">6 Editions Available</Link></h6>
                        </div>
                    </div>
                </div>
                {/* Bids History area start */}
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-md-3 history-area">
                            <h1>Top 9 Bids</h1>
                            <div className="row edition-history">
                                <div className="image">
                                    1.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    2.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    3.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    4.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    5.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    6.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    7.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    8.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                            <div className="row edition-history">
                                <div className="image">
                                    9.<img src={user3} alt="" />
                                </div>
                                <div className="text">
                                    <p>$10,000.00</p>
                                </div>
                                <div className="time">
                                    <p>1m ago</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9"></div>
                    </div>
                    {/* Bids History area ends */}
                </div>
                {/* Item details area end */}
            </div>
        )
    }
};

export default ClosedCollectionDetails;